// extracted by mini-css-extract-plugin
export default {"main":"styles_main__isntI","message":"styles_message__DyY9z","message-fade-out":"styles_message-fade-out__JeIQC"};